import { DeleteOutlined, DiffOutlined, EditOutlined } from '@ant-design/icons';
import { Breadcrumb, Col, Row, Space, Tag } from 'antd';
import { httpCreators, useLoadingSelector } from '@ppvrbh/merchant-frontend-core';
import React, { useEffect, useState } from 'react';
import { FormattedMessage } from 'react-intl';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router';
import { generalCreators } from '../../../redux/general/general-action';
import { DEFAULT_PAGE_SIZE, MODAL_TYPE } from '../../../redux/general/general-constant';
import { GENERAL_STATE_KEY } from '../../../redux/general/general-reducer';
import { RBHAlert, RBHBox, RBHButton, RBHError, RBHTable, RBHText } from '../../../shared/components';
import styleButton from '../../../shared/components/rbh-button/styles';
import styleImage from '../../../shared/components/rbh-image/styles';
import styleText from '../../../shared/components/rbh-text/styles';
import { Colors } from '../../../shared/theme';
import metrics from '../../../shared/theme/metrics';
import { mainCreators } from '../../main-action';
import { MAIN_STATE_KEY } from '../../main-reducer';
import styles from '../VatAddress/styles';
import { FormAddEdit } from './components/FormAddEdit';
import { vatCreators } from './redux/vat-action';
import { VAT_REQUEST_ID_LIST } from './redux/vat-constant';
import { VAT_ALERT, VAT_STATE_KEY, vatStateSelector } from './redux/vat-reducer';
import { vatSagas } from './redux/vat-saga';
import { VatService } from './redux/vat-service';
import stylesHead from './styles';

export const VatAddressScreen: React.FC<Props> = () => {

  const dispatch = useDispatch();
  const history = useHistory();
  const data = useSelector(vatStateSelector(VAT_STATE_KEY.LIST)) as [];
  const alertState = useSelector(vatStateSelector(VAT_STATE_KEY.ALERT_STATE));
  const loading = useLoadingSelector(VAT_REQUEST_ID_LIST.GET_VAT);
  const [edit, setEdit] = useState(null);
  const [editDefault, setEditDefault] = useState<boolean>(false);
  const [selectedItem, setSelectedItem] = useState() as any;
  const [currentPage, setCurrentPage] = useState<number>(1);
  const [ready, setReady] = useState<boolean>(false);

  useEffect(() => {
    dispatch(mainCreators.setMainState(MAIN_STATE_KEY.HEADER_MENU, 3));
    resetReload();
  }, []);

  useEffect(() => {
    if (!!data && data.length > 0) {
      const selected = data.filter((item: any) => item.vatAddressDefaultFlag === true).map((item: any) => item.vatAddressId);
      setSelectedItem(selected?.length > 1 ? [selected[0]] : selected);
    }
    setReady(true);
  }, [data]);

  const pushToVat = () => {
    resetReload();
  };

  const resetReload = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
    setReady(false);
    setEdit(null);
    setEditDefault(false);
    setCurrentPage(1);
    dispatch(vatCreators.callVatAdd());
  };

  const handleCloseAlert = () => {
    dispatch(vatCreators.setVatState(VAT_STATE_KEY.ALERT_STATE, VAT_ALERT.ALERT_BLANK));
  };

  setTimeout(() => {
    handleCloseAlert();
  }, 3000);

  const deleteSuccess = () => {
    setTimeout(() => {
      dispatch(vatCreators.setVatState(VAT_STATE_KEY.ALERT_STATE, VAT_ALERT.ALERT_DELETE_SUCCESS));
    }, 800);
  };

  const deleteFail = () => {
    setTimeout(() => {
      dispatch(vatCreators.setVatState(VAT_STATE_KEY.ALERT_STATE, VAT_ALERT.ALERT_DELETE_FAIL));
    }, 800);
  };

  const toAddVat = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
    history.push('/main/addvataddress');
  };

  const pushToMain = () => {
    history.push('/main');
  };

  const onDelete = (id: any) => {
    dispatch(httpCreators.request({
      id: VAT_REQUEST_ID_LIST.DELETE_VAT,
      sagaHandler: vatSagas.deleteVatHandler as any,
      callbackParams: { resetReload, deleteSuccess, deleteFail },
      service: VatService.deleteVat,
      serviceParams: id
    }));
  };

  const onSaveVatDefault = (vatAddressId: number) => {
    dispatch(httpCreators.request({
      id: VAT_REQUEST_ID_LIST.PATCH_VAT_DEFAULT,
      sagaHandler: vatSagas.patchVatDefaultHandler,
      callbackParams: { resetReload },
      service: VatService.patchVatDefault,
      serviceParams: { vatAddressId }
    }));
  };

  const getVatAddressText = (vat: any) => {
    return (vat.vatAddressProvince === 'กรุงเทพมหานคร' ?
      vat.vatAddressDetail + ' แขวง' + vat.vatAddressSubdistrict + ' เขต' + vat.vatAddressDistrict + ' ' +
      vat.vatAddressProvince + ' ' + vat.vatAddressPostalCode
      : vat.vatAddressDetail + ' ตำบล' + vat.vatAddressSubdistrict + ' อำเภอ' + vat.vatAddressDistrict + ' จังหวัด' +
      vat.vatAddressProvince + ' ' + vat.vatAddressPostalCode);
  };

  const onSetDefaultButton = () => {
    setEditDefault(true);
  };

  const onVatAddressBranch = (vat: any) => {
    const subtitle: string = `${!!vat?.vatAddressBranchNo ? vat?.vatAddressBranchNo + ' -' : ''} ${getVatAddressText(vat)}`;
    dispatch(generalCreators.setGeneralState(GENERAL_STATE_KEY.MODAL, {
      visible: true,
      type: MODAL_TYPE.LIST_VIEW,
      modalTitle: 'main.modal.listview.title',
      modalContent: subtitle,
      modalListContent: vat.shops
    }));
  };

  const rowSelection = {
    type: 'radio',
    onChange: (_selectedRowKeys: React.Key[], selectedRows: any) => {
      setSelectedItem([selectedRows[0].vatAddressId]);
    },
    selectedRowKeys: selectedItem,
    renderCell: (_checked: any, _record: any, index: number, originNode: any) => {
      const dataMerge = {
        props: {
          ...originNode.props,
          'id': 'radio-' + index,
          'data-testid': 'radio-' + index
        }
      };
      const merged = { ...originNode, ...dataMerge };
      return merged;
    },
  };

  const columns = [
    {
      width: metrics.tableHeader.width70,
      title: <FormattedMessage id={'main.vat_branchnum'} />,
      dataIndex: 'vatAddressBranchNo',
      render: (_value: any, all: any, index: number) => {
        const vatAddressBranchNo = 'vatAddressBranchNo-' + index;
        return (<RBHBox style={{ width: metrics.tableHeader.width70 }}>
          <RBHText id={vatAddressBranchNo} style={styleText.textTableContent}>
            {all.vatAddressBranchNo ? all.vatAddressBranchNo : '-'}
          </RBHText>
          {!!selectedItem && all?.vatAddressId === selectedItem[0] && <Tag id={'vatDefaultTag'} color='blue'>
            <FormattedMessage id={'main.vat_vat_default_tag'} /></Tag>}
        </RBHBox>
        );
      }
    },
    {
      width: metrics.base * 11,
      title: <FormattedMessage id={'main.vat_vatid'} />,
      dataIndex: 'vatAddressTaxId',
      render: (_value: any, all: any, index: number) => {
        const vatAddressTaxId = 'vatAddressTaxId-' + index;
        return (<RBHBox style={{ width: metrics.base * 11 }}>
          <RBHText id={vatAddressTaxId} style={styleText.textTableContent}>
            {all.vatAddressTaxId ? all.vatAddressTaxId : '-'}
          </RBHText>
        </RBHBox>
        );
      }
    },
    {
      width: editDefault ? metrics.base * 50.2 : metrics.base * 41,
      title: <FormattedMessage id={'main.vat_form_vataddress'} />,
      dataIndex: 'vatAddressDetail',
      render: (_value: any, all: any, index: number) => {
        return (<RBHBox style={{ width: editDefault ? metrics.base * 50.2 : metrics.base * 41 }}>
          <RBHText id={'vatAddressDetailAddress-' + index} style={styleText.textTableContent}>
            {getVatAddressText(all)}
          </RBHText>
        </RBHBox>);
      },
    },
    {
      width: metrics.base * 7.4,
      title: <FormattedMessage id={'main.vat_vat_address_branch'} />,
      dataIndex: 'vatAddressBranch',
      render: (_value: any, all: any, index: number) => {
        const vatAddressBranch = 'vatAddressBranch-' + index;
        return (<RBHBox style={{ width: metrics.base * 7.4 }}>
          {all?.shops?.length > 0 ? <span id={vatAddressBranch} data-testid={vatAddressBranch}
            style={{ textDecoration: 'underline', color: Colors.lightPurple, cursor: 'pointer' }}
            onClick={() => { onVatAddressBranch(all); }}>
            {`${all?.shops?.length} สาขา`} </span> :
            <RBHText style={styleText.textTableContent} id={vatAddressBranch}>-</RBHText>}
        </RBHBox>);
      }
    },
    {
      width: metrics.doubleBaseMargin,
      title: <FormattedMessage id={'main.edit'} />,
      align: 'center',
      render: (_value: any, all: any, index: any) => {
        const vatAddressEdit = 'vatAddressEdit-' + index;
        return (<RBHBox style={{ width: metrics.doubleBaseMargin }} onClick={() => {
          window.scrollTo({ top: 0, behavior: 'smooth' });
          setEdit(all);
        }}>
          <EditOutlined data-testid={vatAddressEdit} id={vatAddressEdit} translate={null} style={styleImage.iconTable} />
        </RBHBox>);
      },
    },
    {
      width: metrics.doubleBaseMargin,
      title: <FormattedMessage id={'main.vat.vatdelete'} />,
      align: 'center',
      dataIndex: 'vatAddressId',
      render: (vatAddressId: any, _all: any, index: number) => {
        const vatAddressDelete = 'vatAddressDelete-' + index;
        return (Object.keys(data).length <= 1 ? null :
          <RBHBox style={{ width: metrics.doubleBaseMargin }} onClick={() =>
            dispatch(generalCreators.setGeneralState(GENERAL_STATE_KEY.MODAL, {
              visible: true,
              onOk: () => onDelete(vatAddressId),
              modalTitle: 'main.vat_deletecomfirm_header',
              modalContent: 'main.vat_deletecomfirm_content',
              type: MODAL_TYPE.DELETE
            }))}>
            <DeleteOutlined data-testid={vatAddressDelete} id={vatAddressDelete} translate={null} style={styleImage.iconTable} />
          </RBHBox>
        );
      }
    }
  ];

  const getColumns = () => {
    const columnsIndex = [...columns];
    columnsIndex.splice(1, 1);
    return editDefault ? columns.slice(0, columns.length - 2) : columnsIndex;
  };

  const BreadcrumbRender = () => {
    return (
      <RBHBox>
        <Breadcrumb style={styleText.breadCrumb}>
          <Breadcrumb.Item>
            <a id='breakcrumb-vat-tohomepage' style={styleText.breadCrumbItemLink} onClick={() => {
              history.push('/main');
            }}>
              <FormattedMessage id={'main.main'} />
            </a>
          </Breadcrumb.Item>
          <Breadcrumb.Item>
            <span id='breakcrumb-vat' style={styleText.breadCrumbItem}>
              <FormattedMessage id={'main.vat_vataddress'} />
            </span>
          </Breadcrumb.Item>
        </Breadcrumb>
      </RBHBox>
    );
  };

  const BreadcrumbEditRender = () => {
    return (
      <RBHBox>
        <Breadcrumb style={styleText.breadCrumb}>
          <Breadcrumb.Item>
            <a id='breadcrumb-vat-edit-tohomepage' data-testid={'breadcrumb-vat-edit-tohomepage'} style={styleText.breadCrumbItemLink} onClick={() =>
              dispatch(generalCreators.setGeneralState(GENERAL_STATE_KEY.MODAL, {
                visible: true, onOk: pushToMain, type: MODAL_TYPE.CONFIRM_EDIT
              }))}>
              <FormattedMessage id={'main.main'} />
            </a>
          </Breadcrumb.Item>
          <Breadcrumb.Item>
            <a id='breadcrumb-vat-edit-tolistvat' data-testid={'breadcrumb-vat-edit-tolistvat'} style={styleText.breadCrumbItemLink} onClick={() =>
              dispatch(generalCreators.setGeneralState(GENERAL_STATE_KEY.MODAL, {
                visible: true, onOk: pushToVat, type: MODAL_TYPE.CONFIRM_EDIT
              }))}>
              <FormattedMessage id={'main.vat_vataddress'} />
            </a>
          </Breadcrumb.Item>
          <Breadcrumb.Item>
            <span id='breadcrumb-vat-edit' style={styleText.breadCrumbItem}>
              <FormattedMessage id={'main.vat_editaddress'} />
            </span>
          </Breadcrumb.Item>
        </Breadcrumb>
      </RBHBox>
    );
  };

  const TabRender = (props: any) => {
    return (
      <RBHBox style={stylesHead.header}>
        {props.textHeader ? <RBHText style={styleText.headerText} text={props.textHeader} data-testid={'vat_header'} id={'vat_header'} /> : null}
        {data === undefined || Object.keys(data).length <= 0 ? null : !editDefault ?
          <RBHButton id={'vat_addaddress'} style={styleButton.buttonAdd} text={'main.vat_addaddress'} type='primary'
            onClick={toAddVat} icon={<DiffOutlined translate={null} />}>
          </RBHButton> : null
        }
      </RBHBox>
    );
  };

  const mapVatAddressName = () => {
    return (
      // @ts-ignore
      <RBHText id={'vat-vatAddressName-value'} style={styles.vatAddressNameText}>{data[0]?.vatAddressName}</RBHText>
    );
  };

  const mapVatAddressTaxId = () => {
    return (
      // @ts-ignore
      <RBHText id={'vat-vatAddressTaxId-value'} style={styles.vatAddressTaxIdText}>{data[0]?.vatAddressTaxId}</RBHText>
    );
  };

  // const onEditVatData = () => {
  //   dispatch(generalCreators.setGeneralState(GENERAL_STATE_KEY.MODAL, {
  //     visible: true,
  //     type: MODAL_TYPE.EDIT_VAT_INDEX,
  //     modalTitle: 'main.vat.index.editvat',
  //     modalContent: prefillData,
  //     clickClosable: false,
  //     escClosable: false,
  //     resetReload
  //   }));
  // };

  const ButtonRender = () => {
    return (<RBHBox style={{ marginBottom: 20 }}>
      {editDefault ?
        <Row justify={'space-between'} align='middle'>
          <Col flex={'644px'}>
            <RBHText id={'setvatdefault.title'} style={styleText.textRegular16} text={'main.vat_set_default.title'} />
            <RBHText id={'setvatdefault.detail'} style={styleText.textRegular14Gray} text={'main.vat_set_default.detail'} />
          </Col>
          <Row justify='center' align='middle'>
            <Space size={16}>
              <RBHButton text='main.button_cancel' data-testid='button_cancel' id='button_cancel' onClick={resetReload}
                style={styleButton.buttonModalCancelGradient} type='primary' htmlType='button' />
              <RBHButton text='main.button_save' data-testid='button_save' id='button_save' onClick={() => { onSaveVatDefault(selectedItem[0]); }}
                style={styleButton.buttonModalConfirmGradient} type='primary' htmlType='submit' />
            </Space>
          </Row>
        </Row> :
        <Row justify={'space-between'} align='middle'>
          <Col flex={'500px'}>
            <RBHBox style={{ display: 'flex' }}>
              <RBHText text={'main.vat.index.vatname'} data-testid='vat-index-vatname' id={'vat-index-vatname'} style={styleText.textRegular14Gray} />
              {mapVatAddressName()}
            </RBHBox>
            <RBHBox style={{ display: 'flex' }}>
              <RBHText text={'main.vat.index.vatid'} data-testid='vat-index-vatid' id={'vat-index-vatid'} style={styleText.textRegular14Gray} />
              {mapVatAddressTaxId()}
            </RBHBox>
          </Col>
          {/*<Row justify='center' align='middle'>*/}
          {/*  <Space size={16}>*/}
          {/*    <RBHButton text='main.vat.index.editvat' data-testid='vat_editvat' id='vat_editvat' type='primary' htmlType='button'*/}
          {/*      onClick={onEditVatData} style={styleButton.buttonAdd} />*/}
          <RBHButton text={'main.vat_set_default'} data-testid='vat_set_default' id={'vat_set_default'} type='primary'
            onClick={onSetDefaultButton} style={styleButton.buttonAdd} />
          {/*</Space>*/}
          {/*</Row>*/}
        </Row>
      }
    </RBHBox>);
  };

  const TableRender = () => {
    return (
      <RBHBox>
        {ButtonRender()}
        {ready && <RBHTable rowKey={(record: { vatAddressId: any; }) => record.vatAddressId}
          loading={loading} columns={getColumns()} dataSource={data}
          style={{ overflow: 'auto' }}
          rowSelection={editDefault ? rowSelection : null}
          pagination={{
            showSizeChanger: false,
            pageSize: DEFAULT_PAGE_SIZE,
            position: ['bottomLeft'],
            hideOnSinglePage: true,
            current: currentPage,
            onChange: (page: number, _pageSize: number) => {
              setCurrentPage(page);
            },
            showTotal: (total: number, range: number[]) => {
              return (
                <RBHText style={styleText.textPaginationShowTotal}>
                  <FormattedMessage id={'main.showing'} />
                  <span> {range[0] + '-' + range[1]} </span>
                  <FormattedMessage id={'main.of'} />
                  <span> {total}</span>
                </RBHText>);
            }
          }} />}
      </RBHBox>
    );
  };

  const isAlert = () => {
    if (alertState === VAT_ALERT.ALERT_DELETE_SUCCESS) {
      return (
        <RBHBox id={'alertSuccess'} data-testid={'alertSuccess'}>
          <RBHAlert type={'success'} text={'main.vat_delete_vat_success'} afterClose={handleCloseAlert} /><br />
        </RBHBox>
      );
    } else if (alertState === VAT_ALERT.ALERT_DELETE_FAIL) {
      return (
        <RBHBox id={'alertFail'} data-testid={'alertFail'}>
          <RBHAlert type={'error'} text={'main.vat_delete_vat_not_success'} afterClose={handleCloseAlert} /><br />
        </RBHBox>
      );
    } else if (alertState === VAT_ALERT.ALERT_TAXES_SUCCESS) {
      return (
        <RBHBox id={'alertSuccess'} data-testid={'alertSuccess'}>
          <RBHAlert type={'success'} text={'main.vat_taxes_vat_success'} afterClose={handleCloseAlert} /><br />
        </RBHBox>
      );
    } else if (alertState === VAT_ALERT.ALERT_TAXES_FAIL) {
      return (
        <RBHBox id={'alertFail'} data-testid={'alertFail'}>
          <RBHAlert type={'error'} text={'main.vat_taxes_vat_fail'} afterClose={handleCloseAlert} /><br />
        </RBHBox>
      );
    }
  };

  return (
    <RBHBox>
      {isAlert()}
      {edit ? <BreadcrumbEditRender /> : <BreadcrumbRender />}
      {loading ? null :
        edit ?
          <RBHBox>
            <RBHBox style={styles.header}>
              <RBHText style={styleText.headerText} text={'main.vat_editaddress'} data-testid={'vat_edit_header'} id={'vat_edit_header'} />
            </RBHBox>
            <RBHBox style={styles.defaultContent}>
              <FormAddEdit editData={edit} onSuccessCallback={pushToVat} onCancel={() =>
                dispatch(generalCreators.setGeneralState(GENERAL_STATE_KEY.MODAL,
                  { visible: true, onOk: pushToVat, type: MODAL_TYPE.CONFIRM_EDIT }))} />
            </RBHBox>
          </RBHBox>
          :
          <RBHBox>
            <TabRender textHeader={'main.vat_vataddress'} />
            <RBHBox>
              {data === undefined ? <RBHError onOk={() => resetReload()} />
                : Object.keys(data).length <= 0 ? <RBHError onOk={() => resetReload()} />
                  : <RBHBox style={styles.defaultContent}>
                    <TableRender />
                  </RBHBox>}
            </RBHBox>
          </RBHBox>
      }
    </RBHBox>
  );
};

type Props = {};
